import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';

@Component({
  selector: 'app-external-notes',
  templateUrl: './external-notes.component.html',
  styleUrls: ['./external-notes.component.scss']
})
export class ExternalNotesComponent implements OnInit {
  note: string = '';
  isError = false;
  requestId: any;
  constructor(
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private dialogRef: MatDialogRef<ExternalNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.requestId = data.requestId;
    }

  ngOnInit(): void {}
  onCancel() {
    this.dialogRef.close({ data: null })
  }

  onSubmit() {
    if (this.note.trim().length <= 0) {
      this.isError = true;
    } else {
      this.exemptionFilingRequestService
      .addNote(this.requestId, this.note)
      .subscribe((data: any) => {
        console.log(data);
        this.dialogRef.close({ data: this.note })
      });
    }
  }

}
